/**
 * iter76c — Products parent tab. Groups the two catalogs the user
 * manages, per operator request:
 *   • Custom Products  → the existing ProductsTab (contains its own
 *                        SanMar Sync sub-tab, so promoting styles etc.
 *                        works exactly as before)
 *   • Ready-Made       → the existing ReadyMadeTab
 *
 * Bundling these under one top-level nav item cleans up the admin
 * without moving any state or breaking deep-links (the parent starts
 * on "custom" by default so returning users land on the same view).
 */
import { useState } from "react";
import { Layers, ShoppingBag, Image as ImageIcon } from "lucide-react";
import ProductsTab from "./ProductsTab";
import ReadyMadeTab from "./ReadyMadeTab";
import OverridesTab from "./OverridesTab";

const SUBS = [
  { k: "custom", l: "Custom Products", Icon: Layers },
  { k: "ready-made", l: "Ready-Made", Icon: ShoppingBag },
  { k: "overrides", l: "Sync Overrides", Icon: ImageIcon },
];

export default function ProductsParentTab({ pw }) {
  const [sub, setSub] = useState("custom");
  return (
    <div data-testid="products-parent-tab">
      <div className="flex gap-1.5 flex-wrap mb-5 border-b border-[#222] pb-2">
        {SUBS.map(({ k, l, Icon }) => (
          <button
            key={k}
            onClick={() => setSub(k)}
            data-testid={`products-sub-${k}`}
            className={`px-3 py-1.5 border font-mono text-[10px] tracking-widest uppercase inline-flex items-center gap-1.5 ${
              sub === k
                ? "bg-[var(--tc-red)] border-[var(--tc-red)] text-white"
                : "border-[#222] text-zinc-400 hover:text-white"
            }`}
          >
            <Icon size={11} /> {l}
          </button>
        ))}
      </div>
      {sub === "custom" && <ProductsTab pw={pw} />}
      {sub === "ready-made" && <ReadyMadeTab pw={pw} />}
      {sub === "overrides" && <OverridesTab pw={pw} />}
    </div>
  );
}
